<script>
  import { mapState, mapActions } from 'vuex'
  import { TopBar, LoadingOverlay } from '@/components/_shared'
  import { MyAppsList} from '@/components/my-apps'

  export default {
    name: 'my-apps-view',

    components: {
      MyAppsList,
      TopBar,
      LoadingOverlay
    },

    metaInfo: {
      title: 'My Apps'
    },

    computed: {
      ...mapState('myApps', {
        apps: state => state.apps,
        loading: state => state.loading
      })
    },

    methods: {
      ...mapActions('myApps', [
        'loadApps',
        'clearApps'
      ])
    },

    created () {
      this.loadApps()
    },

    destroyed () {
      this.clearApps()
    }
  }
</script>

<template>
  <div>
    <top-bar title="My Apps" icon="layer-group"/>
    <b-container fluid>
      <loading-overlay :is-loading="loading">
        <my-apps-list :apps="apps"/>
      </loading-overlay>
    </b-container>
  </div>
</template>
